import { useV2GetPsaAvailableProjectsQuery } from "@generated";
import { Opt } from "../../types/PsaProject";

const toOpts = (d?: { id?: any; name?: string }[]): Opt[] =>
  (d ?? []).map((r) => ({ value: String(r.id), label: r.name ?? "" }));

export const usePsaAvailableProjects = (
  integrationId: string,
  companyId: string,
  boardId: string,
  opts?: { requireBoard?: boolean }
) => {
  const requireBoard = opts?.requireBoard !== false;
  const { data, isFetching } = useV2GetPsaAvailableProjectsQuery(
    { id: integrationId, companyId, boardId },
    { skip: !companyId || (requireBoard && !boardId) }
  );
  return { projects: toOpts(data?.data), isFetching };
};
